export default "__VITE_ASSET__BtHnpMsB__"